class BESSAppProjectEditorFilterProjectWide extends BESSAppProjectEditorFilter {

    constructor(editor, container) {
        super(editor,
            container.find('.app-filter-project-wide'),
            editor.data.items.length > 1 && editor.data.projectWideEdit);

        this.checkbox = this.node.find('.app-checkbox');
        this.checkbox.setCheckedIf(false);
        this.checkbox.unbind('change').change(this.#onChanged.bind(this));
    }

    updateState() {
        this.updateIsValid(this.editor.data.items.length > 1 && this.editor.data.projectWideEdit)
    }

    #onChanged() {
        let enabled = this.checkbox.isChecked();
        if(enabled) {
            this.editor.enableProjectWideMode();
        } else {
            this.editor.disableProjectWideMode();
        }
    }

    undo() {
        this.editor.disableProjectWideMode(false);
    }
}
